<ng-container *transloco="let t; read: 'conversation-message-template-editor-on-inactive'">
  <app-distinguished-conversation-message-template-editor
    [cardTitle]="t('title')"
    [tempateType]="onInactive"
    [textBoxLabel]="t('label')"
    [textBoxPlaceholder]="t('placeholder')"
  ></app-distinguished-conversation-message-template-editor>
</ng-container>
